import React from 'react';

/*
import {
  _hm,
  _hmDTM,
  _ht,
  cr,
  a,
  ls,
  f,
  gs,
  useMsgz,
  useLdrz,
  BoxC,
  BtnC,
  BtnCttC,
  cmFTH,
  IptC,
  LblC,
  TblC,
  TextC,
  GridC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as BtnCttC from "./_ccmBtnCttC";
import * as TblC from "./_ccmTblC";
import * as _cm from "./_cm";
import * as _cmFTH from "./_cmFTH";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useLdrz } from "./_csLdr";
import { useMsgz } from "./_csMdlMsg";
import * as _ht from './_ht';
import * as _hm from './_hf';
import * as _hmDTM from './_hfDTM';

import * as ihd from './ihd';
import * as ihdI11 from './ihdI11';
import * as ica from './ica';

import * as icvI10___Mz from './icvI10___Mz';
//import * as icvI11___Mz from './icvI11___Mz';

let $i10z = icvI10___Mz.itlI10z();

let $i10rs = [] as _ht.ls;
let $i11rs = [] as _ht.ls;

//let $frcUdt: () => void;

const $BOX = (pz: {
  sPz: _ht.dz,
  abtType: _ht.s,
  i10rz: _ht.dz,
  i101s: _ht.ls,
} & _ht.boxCz) => {

  const _frcUdt = ls.frcUdt(); // このコンポーネントのみを再描画

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  const _i101w = {} as _ht.dz
  _hm.sort(_hm.nd(pz.i101s), 'i101d1110s').map((_i101z: _ht.dz,) => {
    //_hm.l(`icvI10___Ci 80a: ${_hm.s(_i101z.i101d1110s)}, ${_hm.s(_i101z.i101d1120s)}, ${_hm.s(_i101z)}`)
    if (!_i101z.i101d1110s) { // 新規登録時の undefined を考慮し、適用開始日・適用終了日に初期値を設定
      _i101z.i101d1110s = '2020-01-01'
      _i101z.i101d1120s = '9999-12-31'
    }
    const _i101d1110s = _i101z.i101d1110s
//    if (!_i101w[_i101d1110s]) _i101w[_i101d1110s] = { date: _i101d1110s, i101s: [] }
//    _i101w[_i101d1110s].i101s.push(_i101z)
    if (!_i101w[_i101d1110s]) _i101w[_i101d1110s] = []
    _i101w[_i101d1110s].push(_i101z)
  })
  //_hm.l(`icvI10___Ci 80b: ${_hm.s(_i101w)}`)

  //_hm.l(`icvI10__Ci 620: ${_hm.s(_i101w)}`)
  const _oClds = [] as _ht.ls
  Object.keys(_i101w).map((_i101d1110s: _ht.s) => {

    const _hdrs1 = [] as _ht.ls;
    _hdrs1.push({
      cellCs: [
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              ... _abtz.cldz.hdrCz.textCz,
              textz: {
                pfx: '時間帯'
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              ... _abtz.cldz.hdrCz.textCz,
              textz: {
                pfx: ''
              }
            })
          ]
        },
        {
          boxStlz: a('f/3'),
          oClds: [
            cr.c(GridC.N, {
              key: -10,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '１種'
                          }
                        })
                      ]
                    }
                  ],
                },
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '通常月'
                          }
                        })
                      ]
                    }
                  ],
                },
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '平日'
                          }
                        }),
                      ]
                    },
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [                
                        cr.c(TextC.N, {
                          key: -20,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '土曜'
                          }
                        }),
                      ]
                    },
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [                
                        cr.c(TextC.N, {
                          key: -30,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '日祝'
                          }
                        })
                      ]
                    }
                  ],
                },
              ],
            }),
          ]
        },
        {
          boxStlz: a('f/3'),
          oClds: [
            cr.c(GridC.N, {
              key: -10,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '　'
                          }
                        })
                      ]
                    }
                  ],
                },
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '夏時間'
                          }
                        })
                      ]
                    }
                  ],
                },
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '平日'
                          }
                        }),
                      ]
                    },
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [                
                        cr.c(TextC.N, {
                          key: -20,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '土曜'
                          }
                        }),
                      ]
                    },
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [                
                        cr.c(TextC.N, {
                          key: -30,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '日祝'
                          }
                        })
                      ]
                    }
                  ],
                },
              ],
            }),
          ]
        },
        {
          boxStlz: a('f/3'),
          oClds: [
            cr.c(GridC.N, {
              key: -10,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '２種'
                          }
                        })
                      ]
                    }
                  ],
                },
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '通常月'
                          }
                        })
                      ]
                    }
                  ],
                },
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '平日'
                          }
                        }),
                      ]
                    },
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [                
                        cr.c(TextC.N, {
                          key: -20,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '土曜'
                          }
                        }),
                      ]
                    },
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [                
                        cr.c(TextC.N, {
                          key: -30,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '日祝'
                          }
                        })
                      ]
                    }
                  ],
                },
              ],
            }),
          ]
        },
        {
          boxStlz: a('f/3'),
          oClds: [
            cr.c(GridC.N, {
              key: -10,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '　'
                          }
                        })
                      ]
                    }
                  ],
                },
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '夏時間'
                          }
                        })
                      ]
                    }
                  ],
                },
                {
                  boxStlz: a('mb/0'),
                  cellCs: [
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [
                        cr.c(TextC.N, {
                          key: -10,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '平日'
                          }
                        }),
                      ]
                    },
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [                
                        cr.c(TextC.N, {
                          key: -20,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '土曜'
                          }
                        }),
                      ]
                    },
                    {
                      boxStlz: a('fd/rsc'),
                      oClds: [                
                        cr.c(TextC.N, {
                          key: -30,
                          ... _abtz.cldz.hdrCz.textCz,
                          textz: {
                            pfx: '日祝'
                          }
                        })
                      ]
                    }
                  ],
                },
              ],
            }),
          ]
        },
      ],
    });

    const _bdys1 = [] as _ht.ls;
    _hm.nd(_i101w[_i101d1110s]).map( ( i101z: _ht.dz, _nIdx: _ht.n ) => {
      _bdys1.push({
        cellCs: [
          {
            oClds: [
              cr.c(TextC.N, {
                key: -10,
                textz: {
                  pfx: i101z._pfx
                }
              })
            ]
          },
          {
            oClds: [
              cr.c(TextC.N, {
                key: -10,
                abtType: 'lblStfz',
                textz: {
                  pfx: '利用料'
                }
              })
            ]
          },
          {
            boxStlz: a('f/3'),
            oClds: [
              cr.c(GridC.N, {
                key: -10,
                abtType: 'nolineCmnz',
                lineCs: [
                  {
                    cellCs: [
                      {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: i101z.i101a1111i ?? '',
                              onChg: ( _s: _ht.s ) => {
                                i101z.i101a1111i = _s;
                                i101z.i101a1112i = _s;
                                i101z.i101a1113i = _s;
                                i101z.i101a1121i = _s;
                                i101z.i101a1122i = _s;
                                i101z.i101a1123i = _s;
                                i101z.i101a1211i = _s;
                                i101z.i101a1212i = _s;
                                i101z.i101a1213i = _s;
                                i101z.i101a1221i = _s;
                                i101z.i101a1222i = _s;
                                i101z.i101a1223i = _s;
  //                              _frcUdt();
                                _frcUdt();
                              }
                            }
                          })
                        ]
                      },
                      {
                        oClds: [                
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: i101z.i101a1112i ?? '',
                              onChg: ( _s: _ht.s ) => {
                                i101z.i101a1112i = _s;
                              }
                            }
                          })
                        ]
                      },
                      {
                        oClds: [                
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: i101z.i101a1113i ?? '',
                              onChg: ( _s: _ht.s ) => {
                                i101z.i101a1113i = _s;
                              }
                            }
                          })
                        ]
                      }
                    ],
                  },
                ],
              }),
            ]
          },
          {
            boxStlz: a('f/3'),
            oClds: [
              cr.c(GridC.N, {
                key: -10,
                abtType: 'nolineCmnz',
                lineCs: [
                  {
                    cellCs: [
                      {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: i101z.i101a1121i ?? '',
                              onChg: ( _s: _ht.s ) => {
                                i101z.i101a1121i = _s;
                              }
                            }
                          })
                        ]
                      },
                      {
                        oClds: [                
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: i101z.i101a1122i ?? '',
                              onChg: ( _s: _ht.s ) => {
                                i101z.i101a1122i = _s;
                              }
                            }
                          })
                        ]
                      },
                      {
                        oClds: [                
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: i101z.i101a1123i ?? '',
                              onChg: ( _s: _ht.s ) => {
                                i101z.i101a1123i = _s;
                              }
                            }
                          })
                        ]
                      }
                    ],
                  },
                ],
              }),
            ]
          },
          {
            boxStlz: a('f/3'),
            oClds: [
              cr.c(GridC.N, {
                key: -10,
                abtType: 'nolineCmnz',
                lineCs: [
                  {
                    cellCs: [
                      {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: i101z.i101a1211i ?? '',
                              onChg: ( _s: _ht.s ) => {
                                i101z.i101a1211i = _s;
                              }
                            }
                          })
                        ]
                      },
                      {
                        oClds: [                
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: i101z.i101a1212i ?? '',
                              onChg: ( _s: _ht.s ) => {
                                i101z.i101a1212i = _s;
                              }
                            }
                          })
                        ]
                      },
                      {
                        oClds: [                
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: i101z.i101a1213i ?? '',
                              onChg: ( _s: _ht.s ) => {
                                i101z.i101a1213i = _s;
                              }
                            }
                          })
                        ]
                      }
                    ],
                  },
                ],
              }),
            ]
          },
          {
            boxStlz: a('f/3'),
            oClds: [
              cr.c(GridC.N, {
                key: -10,
                abtType: 'nolineCmnz',
                lineCs: [
                  {
                    cellCs: [
                      {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: i101z.i101a1221i ?? '',
                              onChg: ( _s: _ht.s ) => {
                                i101z.i101a1221i = _s;
                              }
                            }
                          })
                        ]
                      },
                      {
                        oClds: [                
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: i101z.i101a1222i ?? '',
                              onChg: ( _s: _ht.s ) => {
                                i101z.i101a1222i = _s;
                              }
                            }
                          })
                        ]
                      },
                      {
                        oClds: [                
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: i101z.i101a1223i ?? '',
                              onChg: ( _s: _ht.s ) => {
                                i101z.i101a1223i = _s;
                              }
                            }
                          })
                        ]
                      }
                    ],
                  },
                ],
              }),
            ]
          },
        ],
      });
    });  


    _oClds.push(
      cr.c(BoxC.N, {
        key: _i101d1110s,
        oClds: [

          cr.c(BoxC.N, {
            key: -1,
            boxStlz: a('dwx/120 f/n fd/rsc'),
            oClds: [

              cr.c(LblC.N, {
                key: -1,
                ... _abtz.crtz.lblCz,
                lblCz: {
                  textz: {
                    pfx: '適用開始日：',
                  }
                },
                cttCz: {
                  oClds: [

                    cr.c(IptC.S, {
                      key: -1,
                      boxStlz: a('dw/14'),
                      cz: {
                        bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                        iptType: 'dtm',
                        vle: _i101d1110s ?? '2000-01-01',
                        onChg: ( _s: _ht.s ) => {
                          pz.i101s.map((_i101z: _ht.dz) => {
                            if (_i101z.i101d1110s == _i101d1110s) {
                              _i101z.i101d1110s = _s
                            }
                          })
                          pz.i101s.map((_i101z: _ht.dz) => { // i101d1120s の設定
                            _i101z.i101d1120s = '9999-12-31'
                            pz.i101s.map((_i101z2: _ht.dz) => {
                              if (
                                _i101z2.i101d1110s > _i101z.i101d1110s &&
                                _i101z2.i101d1110s < _i101z.i101d1120s
                              ) {
                                _i101z.i101d1120s = _hmDTM.addDay(_i101z2.i101d1110s, -1)
                              }
                            })
                          })
                          _frcUdt()
                        }
                      }
                    }),

                    _hm.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
                    cr.c(BtnC.N, {
                      key: -2,
                      ... _abtz.cldz.bdyCz.btnDltCz,
                      boxStlz: a('ml/2'),
                      bfrIconCz: {},
                      lblCz: {},
                      pslPtyz: {
                        onPress: async () => {
                          pz.i101s.map((_i101z: _ht.dz) => {
                            if (_i101z.i101d1110s == _i101d1110s) {
                              _i101z._dlt = 1
                            }
                          })
                          _frcUdt()
                        },
                      }
                    })
                    : undefined,

                  ],
                },
              }),

            ]
          }),

          cr.c(TblC.N, { // 適用開始日別・時間帯別・利用料
            key: -2,
            ... _abtz.cldz.tblCz,
            srlCz: {
              srlStlz: {
                otrz: a('dwx/120 f/n mt/1 mb/4'),
              }
            },
            hdrCz: {
              lineCs: _hdrs1
            },
            bdyCz: {
              lineCs: _bdys1
            }
          }),

        ]
      })
  )
  })

  if (_hm.i(pz.sPz.crt.phs, ['crt', 'udt'])) {
    _oClds.push( // 適用開始日を追加
      cr.c(BtnC.N, {
        key: -10,
        ... _abtz.cldz.bdyCz.btnAddCz,
        bfrIconCz: {},
        lblCz: {},
        pslPtyz: {
          onPress: async () => {

            _hm.l(`icvI10__Ci 848a: ${pz.i10rz.i10ri11r1f}`)
            if (_hm.gt(pz.i10rz.i10ri11r1f, 0)) { // 時間帯区分が指定されている場合
              _hm.l(`icvI10__Ci 848b1: ${_hm.s(pz.i101s)}`)
              let _i101d1110s = '2000-01-01'
              pz.i101s.map((_i101z: _ht.dz) => {
                _hm.l(`icvI10__Ci 848b1: ${_hm.s(_i101z.i101d1110s)}`)
                if (_i101z.i101d1110s > _i101d1110s) {
                  _i101d1110s = _i101z.i101d1110s
                }
              })
              _hm.l(`icvI10__Ci 848c1: ${_i101d1110s}`)
              _i101d1110s = _hmDTM.addDay(_i101d1110s, 1)
              _hm.l(`icvI10__Ci 848c2: ${pz.i10rz.i10ri11r1f}, ${_hm.s(pz.i10rz)}`)
              const _i101s = await _cmFTH.loadLsAsync({
                tgt: 'i111s',
                //cdn: _cmFTH.vdd() + ` AND i111i11r1k=${pz.i10rz.i10ri11r1f}`,
                cdn: _cmFTH.vdd() + ` AND i111i11r1k=(SELECT _key FROM i11rs WHERE COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND _fst = ${pz.i10rz.i10ri11r1f})`,
                fld: '_icn, _pfx, _fst as i101i1111f' + `, '${_i101d1110s}' as i101d1110s`,
              })
              _hm.l(`icvI10__Ci 848d: ${_hm.s(_i101s)}`)
              _i101s.map((_i101z: _ht.dz) => {
                pz.i101s.push(_i101z)
              })
              //_hm.l(`icvI10___Ci 790: ${_hm.s(_i101s)}`)
              _frcUdt()
            }
          },
        }
      })
    )
  }

  return (
    cr.c(BoxC.N, {
      key: -10,
      ...pz,
      oClds: _oClds,
      boxStlz: {
        'boxSizing': 'border-box',
        ... pz.boxStlz,
        ... a('fd/css')
      }
    })
  )
};

export const B = (pz: _ht.btnCttCz) => {
  const _sMsgz = useMsgz();
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {
          const _gUserz = gs.useUserz();
          const _i10rz = $i10z.i10rz;
          const _i102s = $i10z.i102s;
          const _b = await _hm.ectSrlAsync([
            async () => { // 必須項目の確認
              let _b = true;
              if (
                !_hm.f(_i10rz._icn) || // 部屋ID
                !_hm.f(_i10rz._pfx) || // 部屋名
                !(_i10rz.i10ri11r1f > 0) || // 時間帯区分
                !(_i10rz.i10rt1100i > 0) || // 部屋種別
                !(_i10rz.i10ra1100i > 0) || // 連続可能コマ数
                ( 
                  _gUserz.crt.i19rz.i19ra2410i == 1 && 
                  !_hm.f(_i10rz.i10ra3100s)
                ) // 外部連携部屋ID
              ) _b = false;
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: '必須項目が入力されていないため、指定された操作を行うことができません',
                    }
                  }
                })
              }
              return _b;
            },
            async () => { // 時間帯が異なる単体部屋が複合部屋に含まれている
              let _b = true;
              _i102s.filter((_i102z: _ht.dz) => _i102z._dlt != 1).map((_i102z: _ht.dz) => {
                //hf.l(`icvI10___Ci 79: ${hf.s(_i102z)}`);
                const _dz = _hm.getDz($i10rs, _i102z.i102i10r1f, '_fst');
                if (_dz?.i10ri11r1f != _i10rz.i10ri11r1f) _b = false;
              })
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: '時間帯区分の異なる部屋が複合部屋に含まれているため、指定された操作を行うことができません',
                    }
                  }
                })
              }
              return _b;
            },
            async () => { // 時間帯が異なる複合部屋に単体部屋として含まれている
              let _b = true;
              const _ls = await icvI10___Mz.loadI10rLsAsync({
                _31r_fst: _gUserz.crt._31rz._fst,
                i102i10r1f: _i10rz._fst ?? -1, // -1 は新規登録の場合を考慮
              })
              _ls.map((_dz: _ht.dz) => {
                if (_dz?.i10ri11r1f != _i10rz.i10ri11r1f) _b = false;
//hf.l(`icvI10___Ci 98: ${_gUserz.crt._31rz._fst}, ${_i10rz._fst}, ${_dz?.i10ri11r1f}, ${_i10rz.i10ri11r1f}, ${_b}`)
              });
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: '入力している時間帯区分が複合部屋の時間帯区分と異なるため、指定された操作を行うことができません',
                    }
                  }
                })
              }
              return _b;
            },
          ])
          if (_b) {
            const _i10z = await icvI10___Mz.saveI10rDzAsync({
              i10z: $i10z,
            });
            return {
              i10r_fst :_i10z.i10rz._fst,
            };
          }
          else {
            return {}
          }
        }
      }
    })
  );
};

export const D = (pz: _ht.viewDtlCz) => {

  const _frcUdt = ls.frcUdt();
  const _gUserz = gs.useUserz();
  const _sLdrz = useLdrz();

//  _hm.l(`icvI10___Ci 137: ${_hmDTM.getNow()}`)
  React.useEffect(() => {
    _cmFTH.loadAllAsync2({
      phs: pz.sPz.crt.phs,
      frcUdt: _frcUdt,
      ldrz: _sLdrz,
      bfrAsync: () => [
/*
        icvI10___Mz.loadI10rLsAsync({ // < 1 sec
          _31r_fst: _gUserz.crt._31rz._fst,
          i10rt1100i: 10,
        })
        .then((_ls: _ht.ls) => {
          $i10rs = _ls;
        }),
*/
        async () => {
//          _hm.l(`icvI10___Ci 176a: here`)
          $i10rs = await icvI10___Mz.loadI10rLsAsync({ // < 1 sec
            _31r_fst: _gUserz.crt._31rz._fst,
            i10rt1100i: 10,
          })
//          _hm.l(`icvI10___Ci 176b: ${_gUserz.crt._31rz._fst}, ${_hm.s($i10rs)}`)
        },
        async () => {
//          _hm.l(`icvI10___Ci 189a: here`)
          $i11rs = await _cmFTH.loadLsAsync(ihdI11.grtQryLoadI11rLsAsync(_cm.grtUz(), {
            _31r_fst: _gUserz.crt._31rz._fst,
          }));
//          _hm.l(`icvI10___Ci 189b: ${_gUserz.crt._31rz._fst}, ${_hm.s($i11rs)}`)
        },
      ],
      crtAsync: () => [
        async () => {
          $i10z = await icvI10___Mz.crtI10zAsync()
//_hm.l(`icvI10___Ci 1031: ${_hm.s($i10z)}`)
        }
      ],
      udtAsync: () => [
        async () => {
          $i10z = await icvI10___Mz.loadI10rDzAsync({
            i10r_fst: pz.sPz.crt.i10r_fst,
            vsn: pz.sPz.crt.vsn,
          })
        }
      ]
    })
  }, [
    pz.sPz.crt.phs,
    pz.sPz.crt.i10r_fst,
    pz.sPz.crt.vsn,
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  const _hdrs1 = [] as _ht.ls;
  const _bdys1 = [] as _ht.ls;
  const _hdrs2 = [] as _ht.ls;
  const _bdys2 = [] as _ht.ls;

  _hdrs1.push({
    cellCs: [
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.cldz.hdrCz.textCz,
            textz: {
              pfx: '時間帯'
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.cldz.hdrCz.textCz,
            textz: {
              pfx: ''
            }
          })
        ]
      },
      {
        boxStlz: a('f/3'),
        oClds: [
          cr.c(GridC.N, {
            key: -10,
            abtType: 'nolineCmnz',
            lineCs: [
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '１種'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '通常月'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '平日'
                        }
                      }),
                    ]
                  },
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [                
                      cr.c(TextC.N, {
                        key: -20,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '土曜'
                        }
                      }),
                    ]
                  },
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [                
                      cr.c(TextC.N, {
                        key: -30,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '日祝'
                        }
                      })
                    ]
                  }
                ],
              },
            ],
          }),
        ]
      },
      {
        boxStlz: a('f/3'),
        oClds: [
          cr.c(GridC.N, {
            key: -10,
            abtType: 'nolineCmnz',
            lineCs: [
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '　'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '夏時間'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '平日'
                        }
                      }),
                    ]
                  },
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [                
                      cr.c(TextC.N, {
                        key: -20,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '土曜'
                        }
                      }),
                    ]
                  },
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [                
                      cr.c(TextC.N, {
                        key: -30,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '日祝'
                        }
                      })
                    ]
                  }
                ],
              },
            ],
          }),
        ]
      },
      {
        boxStlz: a('f/3'),
        oClds: [
          cr.c(GridC.N, {
            key: -10,
            abtType: 'nolineCmnz',
            lineCs: [
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '２種'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '通常月'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '平日'
                        }
                      }),
                    ]
                  },
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [                
                      cr.c(TextC.N, {
                        key: -20,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '土曜'
                        }
                      }),
                    ]
                  },
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [                
                      cr.c(TextC.N, {
                        key: -30,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '日祝'
                        }
                      })
                    ]
                  }
                ],
              },
            ],
          }),
        ]
      },
      {
        boxStlz: a('f/3'),
        oClds: [
          cr.c(GridC.N, {
            key: -10,
            abtType: 'nolineCmnz',
            lineCs: [
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '　'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '夏時間'
                        }
                      })
                    ]
                  }
                ],
              },
              {
                boxStlz: a('mb/0'),
                cellCs: [
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '平日'
                        }
                      }),
                    ]
                  },
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [                
                      cr.c(TextC.N, {
                        key: -20,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '土曜'
                        }
                      }),
                    ]
                  },
                  {
                    boxStlz: a('fd/rsc'),
                    oClds: [                
                      cr.c(TextC.N, {
                        key: -30,
                        ... _abtz.cldz.hdrCz.textCz,
                        textz: {
                          pfx: '日祝'
                        }
                      })
                    ]
                  }
                ],
              },
            ],
          }),
        ]
      },
    ],
  });

/*
  _bdys1.push({ // 適用開始月
    cellCs: [
      {
        oClds: [
          cr.c(IptC.S, {
            key: -10,
            cz: {
              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
              iptType: 'text',
              vle: i101z.i101d1110s ?? '',
              onChg: ( _s: _ht.s ) => {
                i101z.i101d1110s = _s;
              }
            }
          })
        ]
      },
    ]
  })
*/

/*
  const $i101w = {} as _ht.dz
  _hm.nd($i10z?.i101s).map((_i101z: _ht.dz,) => {
    const _i101d1110s = _i101z.i101d1110s
    if (!$i101w[_i101d1110s]) $i101w[_i101d1110s] = []
    $i101w[_i101d1110s].push(_i101z)
  })
  _hm.l(`icvI10__Ci 620: ${_hm.s($i101w)}`)
  Object.keys($i101w).map((_i101d1110s: _ht.s) => {
    _bdys1.push({ // 適用開始月
      cellCs: [
        {
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                iptType: 'text',
                vle: _i101d1110s ?? '',
                onChg: ( _s: _ht.s ) => {
                  _i101d1110s = _s;
                }
              }
            })
          ]
        },
      ]
    })
  })
*/

  $i10z?.i101s.filter( ( i101z: _ht.dz ) => i101z._dlt != 1 )
  .map( ( i101z: _ht.dz, _nIdx: _ht.n ) => {
    _bdys1.push({
      cellCs: [
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              textz: {
                pfx: i101z._pfx
              }
            })
          ]
        },
        {
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '利用料'
              }
            })
          ]
        },
        {
          boxStlz: a('f/3'),
          oClds: [
            cr.c(GridC.N, {
              key: -10,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  cellCs: [
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i101z.i101a1111i ?? '',
                            onChg: ( _s: _ht.s ) => {
                              i101z.i101a1111i = _s;
                              i101z.i101a1112i = _s;
                              i101z.i101a1113i = _s;
                              i101z.i101a1121i = _s;
                              i101z.i101a1122i = _s;
                              i101z.i101a1123i = _s;
                              i101z.i101a1211i = _s;
                              i101z.i101a1212i = _s;
                              i101z.i101a1213i = _s;
                              i101z.i101a1221i = _s;
                              i101z.i101a1222i = _s;
                              i101z.i101a1223i = _s;
//                              _frcUdt();
                              _frcUdt();
                            }
                          }
                        })
                      ]
                    },
                    {
                      oClds: [                
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i101z.i101a1112i ?? '',
                            onChg: ( _s: _ht.s ) => {
                              i101z.i101a1112i = _s;
                            }
                          }
                        })
                      ]
                    },
                    {
                      oClds: [                
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i101z.i101a1113i ?? '',
                            onChg: ( _s: _ht.s ) => {
                              i101z.i101a1113i = _s;
                            }
                          }
                        })
                      ]
                    }
                  ],
                },
              ],
            }),
          ]
        },
        {
          boxStlz: a('f/3'),
          oClds: [
            cr.c(GridC.N, {
              key: -10,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  cellCs: [
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i101z.i101a1121i ?? '',
                            onChg: ( _s: _ht.s ) => {
                              i101z.i101a1121i = _s;
                            }
                          }
                        })
                      ]
                    },
                    {
                      oClds: [                
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i101z.i101a1122i ?? '',
                            onChg: ( _s: _ht.s ) => {
                              i101z.i101a1122i = _s;
                            }
                          }
                        })
                      ]
                    },
                    {
                      oClds: [                
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i101z.i101a1123i ?? '',
                            onChg: ( _s: _ht.s ) => {
                              i101z.i101a1123i = _s;
                            }
                          }
                        })
                      ]
                    }
                  ],
                },
              ],
            }),
          ]
        },
        {
          boxStlz: a('f/3'),
          oClds: [
            cr.c(GridC.N, {
              key: -10,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  cellCs: [
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i101z.i101a1211i ?? '',
                            onChg: ( _s: _ht.s ) => {
                              i101z.i101a1211i = _s;
                            }
                          }
                        })
                      ]
                    },
                    {
                      oClds: [                
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i101z.i101a1212i ?? '',
                            onChg: ( _s: _ht.s ) => {
                              i101z.i101a1212i = _s;
                            }
                          }
                        })
                      ]
                    },
                    {
                      oClds: [                
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i101z.i101a1213i ?? '',
                            onChg: ( _s: _ht.s ) => {
                              i101z.i101a1213i = _s;
                            }
                          }
                        })
                      ]
                    }
                  ],
                },
              ],
            }),
          ]
        },
        {
          boxStlz: a('f/3'),
          oClds: [
            cr.c(GridC.N, {
              key: -10,
              abtType: 'nolineCmnz',
              lineCs: [
                {
                  cellCs: [
                    {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i101z.i101a1221i ?? '',
                            onChg: ( _s: _ht.s ) => {
                              i101z.i101a1221i = _s;
                            }
                          }
                        })
                      ]
                    },
                    {
                      oClds: [                
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i101z.i101a1222i ?? '',
                            onChg: ( _s: _ht.s ) => {
                              i101z.i101a1222i = _s;
                            }
                          }
                        })
                      ]
                    },
                    {
                      oClds: [                
                        cr.c(IptC.S, {
                          key: -10,
                          cz: {
                            bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                            iptType: 'text',
                            vle: i101z.i101a1223i ?? '',
                            onChg: ( _s: _ht.s ) => {
                              i101z.i101a1223i = _s;
                            }
                          }
                        })
                      ]
                    }
                  ],
                },
              ],
            }),
          ]
        },
      ],
    });
  });  

  _hdrs2.push({
    cellCs: [
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.cldz.hdrCz.textCz,
            textz: {
              pfx: '複合部屋'
            }
          })
        ]
      },
    ],
  });

  $i10z?.i102s.filter( ( i102z: _ht.dz ) => i102z._dlt != 1 )
  .map( ( i102z: _ht.dz, _nIdx: _ht.n ) => {
    _bdys2.push({
      cellCs: [
        {
          boxStlz: a('f/1'),
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                iptType: 'pcr',
                ls: $i10rs,
                vle: i102z.i102i10r1f ?? '',
                onChg: ( _dz: _ht.dz ) => {
                  i102z.i102i10r1f = _dz._fst;
                }
              }
            })
          ]
        },
        {
          boxStlz: a('dw/10 f/n'),
          oClds: [
            _hm.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnDltCz,
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  i102z._dlt = 1;
                  _frcUdt();
                },
              }
            })
            : null,
          ]
        },
      ],
    });
  });  
  if ( _hm.i(pz.sPz.crt.phs, ['crt', 'udt']) ) {
    _bdys2.push({
      cellCs: [
        {
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnAddCz,
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  $i10z?.i102s.push({
                    i102i10r1f: -1,
                  });
                  _frcUdt();
                },
              }
            })
          ]
        },
      ],
    });
  }

  return (
    cr.c(BoxC.N, {
      key: -10999,
      boxStlz: a('dw/f fd/csc'),
      oClds: [

        _hm.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
        cr.c(TextC.N, {
          key: -101,
          abtType: 'rmkCmnz',
          boxStlz: a(`dw/f fd/rsc mb/1`),
          textz: {
            pfx: '※：必須'
          }
        })
        : null,

        cr.c(GridC.N, {
          key: -202,
          abtType: 'nolineCmnz',
          boxStlz: a('dwx/60 mb/2 mh/a'),
          lineCs: [
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -103,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/14`),
                        textz: {
                          pfx: '部屋ID：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -104,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i10z?.i10rz._icn ?? '',
                              onChg: ( _s: _ht.s ) => {
                                $i10z.i10rz._icn = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        _hm.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -105,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/14`),
                        textz: {
                          pfx: '部屋名：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -106,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i10z?.i10rz._pfx ?? '',
                              onChg: ( _s: _ht.s ) => {
                                $i10z.i10rz._pfx = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        _hm.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -107,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/14`),
                        textz: {
                          pfx: '時間帯区分：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -108,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: $i11rs,
                              vle: $i10z?.i10rz.i10ri11r1f,
                              onChg: ( _dz: _ht.dz ) => {
                                //_hm.l(`icvI10___Ci 1969: ${_hm.s(_dz)}`)
//                                $i10z.i10rz.i10ri11r1f = _dz.key;
                                $i10z.i10rz.i10ri11r1f = _dz._fst;
                                _cmFTH.loadLsAsync({
                                  tgt: 'i111s',
                                  cdn: _cmFTH.vdd() + ` AND i111i11r1k=${_dz._key}`, // _fst でなく _key
                                  fld: '_icn, _pfx, _fst as i101i1111f',
                                })
                                .then( ( _ls: _ht.ls ) => {
                                  $i10z.i101s = _hm.sort(_ls);
                                  //_hm.l(`icvI10___Ci 1983: ${_hm.s($i10z.i101s)}`)
                                  _frcUdt();
                                });
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        _hm.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -109,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/14`),
                        textz: {
                          pfx: '部屋種別：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -1010,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: ihd.f('i10rt1100i').ls,
                              vle: $i10z?.i10rz.i10rt1100i ?? 10,
                              onChg: ( _dz: _ht.dz ) => {
                                $i10z.i10rz.i10rt1100i = _dz.key;
                                _frcUdt();
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        _hm.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -1011,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/14`),
                        textz: {
                          pfx: '連続コマ数：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -1012,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i10z?.i10rz.i10ra1100i,
                              onChg: ( _s: _ht.s ) => {
                                $i10z.i10rz.i10ra1100i = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        _hm.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -1013,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/14`),
                        textz: {
                          pfx: '延長料：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -1014,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i10z?.i10rz.i10ra2100i,
                              onChg: ( _s: _ht.s ) => {
                                $i10z.i10rz.i10ra2100i = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            _gUserz.crt.i19rz.i19ra2410i == 1?
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -1015,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/14`),
                        textz: {
                          pfx: '外部連携ID：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -1016,
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $i10z?.i10rz.i10ra3100s,
                              onChg: ( _s: _ht.s ) => {
                                $i10z.i10rz.i10ra3100s = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        _hm.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            }
            : undefined,
          ]
        }),

/*
        cr.c(TblC.N, { // 適用開始日別・時間帯別・利用料
          key: -30,
          ... _abtz.cldz.tblCz,
          srlCz: {
            srlStlz: {
              otrz: a('dwx/120 f/n mb/2'),
            }
          },
          hdrCz: {
            lineCs: _hdrs1
          },
          bdyCz: {
            lineCs: _bdys1
          }
        }),
*/

        cr.c($BOX, {
          key: -32,
          sPz: pz.sPz,
          abtType: pz.abtType,
          i10rz: $i10z?.i10rz,
          i101s: $i10z?.i101s,
        }),

        $i10z?.i10rz.i10rt1100i == 20 ? // 複合部屋
        cr.c(TblC.N, {
          key: -40,
          ... _abtz.cldz.tblCz,
          srlCz: {
            srlStlz: {
              otrz: a('dwx/35 f/n'),
            }
          },
          hdrCz: {
            lineCs: _hdrs2
          },
          bdyCz: {
            lineCs: _bdys2
          }
        })
        : null,

      ]

    })

  );
};

